import React from "react";
import Chat from "../features/chatbot/Chat";
import "../styles/chatbot.css";

const ChatBotRoutes = () => {
    return (
        <div className="chatbot-app-container">
            <Chat />
        </div>
    );
}

export default ChatBotRoutes;
